import amd from "../images/partners/amd.png";

import ese from "../images/partners/ese.png";
import hive from "../images/partners/hive.png";
import bnb from "../images/partners/bnb.png";
import pga from "../images/partners/pga.png";
import polygon from "../images/partners/polygon.png";
import elympics from "../images/partners/elympics.png";
import kb from "../images/partners/kb.png";
import metapro from "../images/partners/metapro.png";
import guia from "../images/partners/guia.webp";
import bitcoinInsider from "../images/partners/bitcoinInsider.webp";

export interface PartnersProps {
  logo: string;
  name: string;
  url: string;
}

export const partnersData: PartnersProps[] = [
  {
    logo: amd,
    name: "AMD",
    url: process.env.GATSBY_AMD_URL,
  },
  {
    logo: polygon,
    name: "Polygon",
    url: process.env.GATSBY_POLYGON_URL,
  },
  {
    logo: bnb,
    name: "Bnb",
    url: process.env.GATSBY_BNB_URL,
  },
  {
    logo: elympics,
    name: "Elympics",
    url: process.env.GATSBY_ELYMPICS_URL,
  },
  {
    logo: pga,
    name: "PGA",
    url: process.env.GATSBY_PGA_URL,
  },
  {
    logo: ese,
    name: "ESE",
    url: process.env.GATSBY_ESE_URL,
  },
  {
    logo: hive,
    name: "Hive",
    url: "",
  },
  {
    logo: kb,
    name: "KarolBasz",
    url: process.env.GATSBY_KB_URL,
  },
  {
    logo: metapro,
    name: "metapro",
    url: process.env.GATSBY_METAPRO_URL,
  },
  {
    logo: guia,
    name: "guia",
    url: process.env.GATSBY_GUIA_URL,
  },
  {
    logo: bitcoinInsider,
    name: "bitcoinInsider",
    url: process.env.GATSBY_BITCOIN_INSIDER_URL,
  },
];
